import React from "react";
import EbDialog from "../../../ExecutionBlueprint/ExecutionBlueprintLiveReview/_shared/EbDialog";

// The one delete confirmation for the whole flow — nothing deletes on a
// single click. Same EbDialog the Execution Blueprint and Annual OKRs use.
const QokrConfirmDelete = ({
  title,
  children,
  confirmLabel = "Delete",
  busy = false,
  onConfirm,
  onClose,
}) => (
  <EbDialog
    isOpen
    size="sm"
    tone="danger"
    icon={<i className="fa-solid fa-trash-can" aria-hidden="true" />}
    title={title}
    busy={busy}
    onClose={onClose}
    actions={[
      { label: "Cancel", variant: "ghost", onClick: onClose },
      {
        label: confirmLabel,
        loadingLabel: "Deleting…",
        variant: "danger",
        loading: busy,
        onClick: onConfirm,
      },
    ]}
  >
    {children}
  </EbDialog>
);

export default QokrConfirmDelete;
